import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "./styles.scss";

export const EmptyCard = ({ className, text }) => {
  return (
    <div className={createClassNameString([className, "EmptyCard--empty-container"])}>
      <div className="EmptyCard--empty">
        <p className="EmptyCard--empty-text">{text}</p>
      </div>
    </div>
  );
};
